<template>
    <div class="mt-4 pr-2 pl-2 pt-2 border_all" style="border: thin solid rgba(0,0,0,.12)" elevation="0">
        <v-toolbar elevation="0">
            <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="search"
                    hide-details
                    class="hidden-sm-and-down"
            ></v-text-field>
            <v-spacer></v-spacer>
            <div class="mt-6">
                <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="opsitableHistoriWallet.awal"
                                label="Tanggal Awal"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="opsitableHistoriWallet.awal" @input="menu1 = false"></v-date-picker>
                </v-menu>
            </div>
            <div class="mt-6">
                <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="opsitableHistoriWallet.akhir"
                                label="Tanggal Akhir"
                                prepend-icon="event"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="opsitableHistoriWallet.akhir" @input="menu2 = false"></v-date-picker>
                </v-menu>
            </div>
            <v-btn class="ml-2" color="primary" @click.native="getHistoriWallet(opsitableHistoriWallet)">
                <v-icon dark>refresh</v-icon>Refresh
            </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
                :headers="headers"
                :search="search"
                :items="wallethistori"
                class="elevation-0"
                item-key="id"
                :options.sync="opsitableHistoriWallet"
                :server-items-length="total_histori"
                :loading="loading"
                @update:options="getHistoriWallet(opsitableHistoriWallet)"
        >
            <template v-slot:item.credit="{ item }">
                <div class="text-right">
                    {{formatAngka(item.credit)}}
                </div>
            </template>
            <template v-slot:item.debet="{ item }">
                <div class="text-right">
                    {{formatAngka(item.debet)}}
                </div>
            </template>
            <template v-slot:item.endbalance="{ item }">
                <div class="text-right">
                    {{formatAngka(item.endbalance)}}
                </div>
            </template>
            <template v-slot:item.createdat="{ item }">
                {{formatDate(item.createdat)}}
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import moment from "moment";
    import {mapActions, mapState} from "vuex";
    import Utils from "@/plugins/utils";

    export default {
        name: "HistoryWallet",
        data: ()=>({
            search: '',
            menu1: false,
            menu2: false,
            dateawal: moment().add(7,'hours').toISOString().substr(0, 10),
            dateakhir: moment().add(7,'hours').toISOString().substr(0, 10),
            opsitableHistoriWallet: {
                search:'',
                itemsPerPage: 10,
                page:1,
                sortBy: ["id"],
                awal: moment().add(7,'hours').toISOString().substr(0, 10),
                akhir: moment().add(7,'hours').toISOString().substr(0, 10),
            },
            headers: [
                {
                    text: 'id',
                    value: 'id'
                },
                {
                    text: 'Debet',
                    value: 'debet'
                },
                {
                    text: 'Credit',
                    value: 'credit'
                },
                {
                    text: 'Description',
                    value: 'description'
                },
                {
                    text: 'Balance',
                    value: 'endbalance'
                },
                {
                    text: 'Created At',
                    value: 'createdat'
                }
            ],
        }),
        computed: {
            ...mapState('Wallet',['loading','dialog','wallethistori','total_histori','walletbanks'])
        },
        methods: {
            ...mapActions('Wallet',['getHistoriWallet']),
            formatAngka(val){
                return Utils.formatAngka(val)
            },
            formatDate (value) {
                return moment(value).add(7,'hours').format("YYYY/MM/DD HH:mm:ss")
            },
            statusformat (value) {
                let a = 'Proses'
                if (value === 1) {
                    a = 'Sukses'
                }
                return a
            },
        }
    }
</script>

<style scoped>

</style>
